'use client';

import { LeadForm } from '@/app/components/form-kit/lead-form';
import { useModalStateResult } from '@/app/components/sections/register/modals/hooks/useModalStateResult';
import { ModalStatusResult } from '@/app/components/sections/register/modals/modal-status-result';
import {
  type RegisterFormSchemaType,
  type RegisterFormWrapperProps,
} from '@/app/cv/components/sections/register/types';
import {
  createBaseLeadFormSchema,
  createLeadFormWithLineIdSchema,
  createLeadFormWithProvinceSchema,
} from '@/app/lib/forms/schemas/lead-form.schema';

const schemaMap: Record<
  RegisterFormSchemaType,
  ReturnType<typeof createBaseLeadFormSchema>
> = {
  default: createLeadFormWithProvinceSchema(),
  minimal: createBaseLeadFormSchema(),
  'with-line-id': createLeadFormWithLineIdSchema(),
};

export const RegisterFormWrapper = ({
  schemaType = 'default',
  theme = 'light',
  successMsg,
  buttons = [],
  ...props
}: RegisterFormWrapperProps) => {
  const schema = schemaMap[schemaType];
  const { modalState, handleSuccess, handleError, onClose } =
    useModalStateResult();

  return (
    <>
      <LeadForm
        {...props}
        theme={theme}
        schema={schema}
        provinces={props.provinces || []}
        onSuccess={handleSuccess}
        onError={handleError}
      />
      <ModalStatusResult
        modalState={modalState}
        theme={theme}
        successMsg={successMsg}
        buttons={buttons}
        onClose={onClose}
      />
    </>
  );
};
